import { Font } from "./lib-font-ext/lib-font-ext";
import debug from "debug";
import { getFeatureStandardName } from "./feature-names";

const log = debug("font-parsing");

export function loadFont(fontInfo) {
  console.log("loadFont", fontInfo);
  if (!fontInfo.src) {
    return Promise.reject(`No font src in ${JSON.stringify(fontInfo)}`);
  }
  return new Promise((resolve, reject) => {
    const myFont = new Font(fontInfo.name, { ext: fontInfo.ext });
    myFont.onerror = (evt) => {
      log("Font onerror callback", evt);
      return reject(new Error(evt.toString()));
    };
    myFont.onload = (evt) => resolve(evt.detail.font);
    myFont.src = fontInfo.src;
  });
}

export async function getFontFeatures(fontInfo) {
  log("getFontFeatures", fontInfo);
  const font = await loadFont(fontInfo);

  log("tables", font.opentype.tables);

  const GSUB = font.opentype.tables.GSUB;

  const features = new Set();
  const names = {};

  GSUB.getSupportedScripts().forEach((script) => {
    const scriptTable = GSUB.getScriptTable(script);
    GSUB.getSupportedLangSys(scriptTable).forEach((langSys) => {
      const langSysTable = GSUB.getLangSysTable(script, langSys);
      GSUB.getFeatures(langSysTable)?.forEach((feature) => {
        features.add(feature.featureTag);
        const uiNameId = feature.getFeatureParams()?.UINameID;
        const name = uiNameId
          ? font.opentype.tables.name.get(uiNameId)
          : getFeatureStandardName(feature.featureTag);

        if (
          name &&
          names[feature.featureTag] &&
          names[feature.featureTag] !== name
        ) {
          console.warn(
            `Feature ${feature.featureTag} has multiple names: ${
              names[feature.featureTag]
            } and ${name}`
          );
        }

        names[feature.featureTag] = name;
      });
    });
    console.groupEnd();
  });

  return Array.from(features).map((feature) => ({
    tag: feature,
    name: names[feature],
  }));
}

export async function getFontVariations(fontInfo) {
  const font = await loadFont(fontInfo);
  const fvar = font?.opentype?.tables?.fvar;
  const axes = fvar?.axes || fvar?.axis || [];
  return axes
    .map((axis) => {
      const tag = axis.tag || axis.axisTag;
      const name =
        axis.name ||
        (axis.axisNameID && font?.opentype?.tables?.name?.get(axis.axisNameID));
      const min = axis.minValue ?? axis.min;
      const max = axis.maxValue ?? axis.max;
      const defaultValue = axis.defaultValue ?? axis.default ?? min;
      if (tag == null || min == null || max == null) return null;
      return { tag, name, min, max, default: defaultValue };
    })
    .filter((axis) => axis);
}
